import { createPlugin } from 'leva/plugin'
import { ConfigPanel } from './ConfigPanel'
import { normalize, sanitize } from '../utilities/config'

export const config = createPlugin({
  normalize,
  sanitize,
  component: ConfigPanel,
})